// src/utils/formatDate.js
export function formatDateToDDMMYYYY(dateString) {
  if (!dateString) return '';
  
  // Prevent timezone shift for YYYY-MM-DD strings
  if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString.trim())) {
    const [year, month, day] = dateString.trim().split('-');
    return `${day}-${month}-${year}`;
  }
  // Prevent timezone shift for YYYY-MM-DDTHH:mm:ss strings by taking the date part
  if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(dateString.trim())) {
    const [year, month, day] = dateString.trim().split('T')[0].split('-');
    return `${day}-${month}-${year}`;
  }

  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export function formatDateToDDMMYYYY_HHMMSS(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date)) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
}
